import { render } from "./AppNavbar.vue?vue&type=template&id=04da2c48&scoped=true&ts=true"
import script from "./AppNavbar.vue?vue&type=script&lang=ts"
export * from "./AppNavbar.vue?vue&type=script&lang=ts"

import "./AppNavbar.vue?vue&type=style&index=0&id=04da2c48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04da2c48"]])

export default __exports__